<kort id="gruppe-sakstyper" #kort>
  <kort-tittel>
    {{ 'Sakstyper' | translate }}
    <div class="antall">{{ '{antall} sakstyper' | translate: {antall: sakstyper().length} }}</div>
  </kort-tittel>

  @if (visning()) {
    @if (!kort.erAktiv()) {
      <p>{{ 'Bruk sakstyper til å gruppere saker og si noe om hvordan de behandles. Typiske sakstyper er beslutning, orientering og diskusjon.' | translate }}</p>
      <kort-handlinger>
        <button mat-button (click)="visDetaljer()" data-testid="vis-alle-knapp">
          <mat-icon>list</mat-icon>
          {{ 'Vis alle' | translate }}
        </button>
      </kort-handlinger>

    } @else {
      <div class="innhold-kontainer">
        <table>
          <thead>
          <tr>
            <th>{{ 'Navn' | translate }}</th>
            <th>{{ 'I bruk' | translate }}</th>
          </tr>
          </thead>
          <tbody>
            @for (sakstype of sakstyper(); track sakstype.id) {
              <tr data-testid="sakstype">
                <td data-testid="navn">{{ sakstype.navn }}</td>
                <td>
                  <mat-icon>{{ sakstype.kanIkkeSlettes ? 'check_circle' : 'circle' }}</mat-icon>
                </td>
              </tr>
            }
          <tbody>
        </table>
      </div>
      <kort-handlinger>
        <button mat-button (click)="skjulDetaljer()">{{ 'Skjul' | translate }}</button>
        <button mat-button (click)="rediger()" data-testid="rediger-knapp">
          <mat-icon>edit</mat-icon>
          {{ 'Rediger' | translate }}
        </button>
      </kort-handlinger>
    }

  } @else {
    <gruppe-sakstype-rediger-liste
            [sakstyper]="sakstyper()"
            [gruppeId]="gruppeId()"
            (vedFerdig)="redigeringFerdig($event)"/>
  }
</kort>
